/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuildFileDto } from '../../models/build-file-dto';

export interface BuildFileControllerUpdate$Params {
  id: string;
      body: {
'file'?: Blob;
}
}

export function buildFileControllerUpdate(http: HttpClient, rootUrl: string, params: BuildFileControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BuildFileDto>> {
  const rb = new RequestBuilder(rootUrl, buildFileControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuildFileDto>;
    })
  );
}

buildFileControllerUpdate.PATH = '/api/build-file/{id}';
